import React from 'react';
import PropTypes from 'prop-types';

const StepTitle = (props) => {
  const { text, className } = props;

  return (
    <div className={`stepTitle ${className}`}>{text}</div>
  );

};

StepTitle.defaultProps = {
  text: '',
  className: '',
};

StepTitle.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default StepTitle;